import { DaymapQuery as u } from "../../daymapQuery.js";
var e;
((t) => {
  class r extends u {
    constructor(s) {
      super(
        ["studentrubricresults", s.studentId, s.taskId],
        s,
        `/lms/api/assessment/studentresults/rubrics?studentId=${s.studentId}&taskId=${s.taskId}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minutes
      );
    }
  }
  t.StudentRubricResults = r;
  class d extends u {
    constructor(s) {
      super(
        ["rubric", s.rubricId],
        s,
        `/lms/api/assessment/rubric/${s.rubricId}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minutes
      );
    }
  }
  t.Rubrics = d;
})(e || (e = {}));
export {
  e as rubrics
};
//# sourceMappingURL=index.js.map
